<template>
	<tab_header
		icon="fa-solid fa-computer"
		title="Configuração do computador" />

	<div class="row flex-column flex-md-row rounded border p-5">
		<div class="col-12 col-lg-4">
			<ul
				class="nav nav-tabs nav-pills flex-row border-0 flex-md-column me-5 mb-3 mb-md-0 fs-6 min-w-lg-200px">
				<li class="nav-item w-100 me-0 mb-md-2">
					<a
						class="nav-link active w-100 btn btn-flex btn-active-light-info"
						data-bs-toggle="tab"
						href="#kt_vtab_pane_1">
						<span class="d-flex flex-column align-items-start">
							<span class="fs-4 fw-bold">Configuração</span>
						</span>
					</a>
				</li>
				<li class="nav-item w-100 me-0 mb-md-2">
					<a
						class="nav-link w-100 btn btn-flex btn-active-light-info"
						data-bs-toggle="tab"
						href="#kt_vtab_pane_2">
						<span class="d-flex flex-column align-items-start">
							<span class="fs-4 fw-bold">CPU</span>
						</span>
					</a>
				</li>
				<li class="nav-item w-100 me-0 mb-md-2">
					<a
						class="nav-link w-100 btn btn-flex btn-active-light-info"
						data-bs-toggle="tab"
						href="#kt_vtab_pane_3">
						<span class="d-flex flex-column align-items-start">
							<span class="fs-4 fw-bold"
								>Informações do sistema</span
							>
						</span>
					</a>
				</li>
				<li class="nav-item w-100 me-0 mb-md-2">
					<a
						class="nav-link w-100 btn btn-flex btn-active-light-info"
						data-bs-toggle="tab"
						href="#kt_vtab_pane_4">
						<span class="d-flex flex-column align-items-start">
							<span class="fs-4 fw-bold">Partições de disco</span>
						</span>
					</a>
				</li>
				<li class="nav-item w-100 me-0 mb-md-2">
					<a
						class="nav-link w-100 btn btn-flex btn-active-light-info"
						data-bs-toggle="tab"
						href="#kt_vtab_pane_5">
						<span class="d-flex flex-column align-items-start">
							<span class="fs-4 fw-bold">Plataforma</span>
						</span>
					</a>
				</li>
				<li class="nav-item w-100 me-0 mb-md-2">
					<a
						class="nav-link w-100 btn btn-flex btn-active-light-info"
						data-bs-toggle="tab"
						href="#kt_vtab_pane_6">
						<span class="d-flex flex-column align-items-start">
							<span class="fs-4 fw-bold"
								>Programas instalados</span
							>
						</span>
					</a>
				</li>
				<li class="nav-item w-100 me-0 mb-md-2">
					<a
						class="nav-link w-100 btn btn-flex btn-active-light-info"
						data-bs-toggle="tab"
						href="#kt_vtab_pane_7">
						<span class="d-flex flex-column align-items-start">
							<span class="fs-4 fw-bold">Rede</span>
						</span>
					</a>
				</li>
				<li class="nav-item w-100 me-0 mb-md-2">
					<a
						class="nav-link w-100 btn btn-flex btn-active-light-info"
						data-bs-toggle="tab"
						href="#kt_vtab_pane_8">
						<span class="d-flex flex-column align-items-start">
							<span class="fs-4 fw-bold"
								>Sistema operacional</span
							>
						</span>
					</a>
				</li>
				<li class="nav-item w-100 me-0 mb-md-2">
					<a
						class="nav-link w-100 btn btn-flex btn-active-light-info"
						data-bs-toggle="tab"
						href="#kt_vtab_pane_9">
						<span class="d-flex flex-column align-items-start">
							<span class="fs-4 fw-bold">Usuários logados</span>
						</span>
					</a>
				</li>
			</ul>
		</div>

		<div class="tab-content col-12 col-lg-8" id="myTabContent">
			<div
				class="tab-pane fade show active"
				id="kt_vtab_pane_1"
				role="tabpanel">
				<computer_details_tab
					:computer_uid="props.computer_uid"
					:find_agent_url="props.find_agent_url"
					:block_computer_url="props.block_computer_url"
					:scan_computer_url="props.scan_computer_url" />
			</div>

			<div class="tab-pane fade show" id="kt_vtab_pane_2" role="tabpanel">
				<cpu_info_tab :cpu_info="props.computer_info.cpu_info" />
			</div>

			<div class="tab-pane fade show" id="kt_vtab_pane_3" role="tabpanel">
				<system_info_tab
					:system_info="props.computer_info.system_info" />
			</div>

			<div class="tab-pane fade show" id="kt_vtab_pane_4" role="tabpanel">
				<disk_partitions_tab
					:partitions="props.computer_info.partitions" />
			</div>

			<div class="tab-pane fade show" id="kt_vtab_pane_5" role="tabpanel">
				<platform_info_tab
					:platform_info="props.computer_info.platform" />
			</div>

			<div class="tab-pane fade show" id="kt_vtab_pane_6" role="tabpanel">
				<software_installed_tab
					:softwares="props.computer_info.softwares" />
			</div>

			<div class="tab-pane fade show" id="kt_vtab_pane_7" role="tabpanel">
				<network_info_tab
					:network_info="props.computer_info.network_info" />
			</div>

			<div class="tab-pane fade show" id="kt_vtab_pane_8" role="tabpanel">
				<os_info_tab :os_info="props.computer_info.os" />
			</div>

			<div class="tab-pane fade show" id="kt_vtab_pane_9" role="tabpanel">
				<logged_in_users_tab
					:users="props.computer_info.logged_in_users" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import tab_header from './tab_header.vue';
	import computer_details_tab from './computer_details_tab.vue';
	import software_installed_tab from './software_installed_tab.vue';
	import cpu_info_tab from './cpu_info_tab.vue';
	import system_info_tab from './system_info_tab.vue';
	import disk_partitions_tab from './disk_partitions_tab.vue';
	import platform_info_tab from './platform_info_tab.vue';
	import network_info_tab from './network_info_tab.vue';
	import os_info_tab from './os_info_tab.vue';
	import logged_in_users_tab from './logged_in_users_tab.vue';

	import { provide } from 'vue';

	const props = defineProps({
		computer_uid: { type: String, required: true },
		find_agent_url: { type: String, required: true },
		block_computer_url: { type: String, required: true },
		scan_computer_url: { type: String, required: true },
		computer_info: { type: Object, required: true },
	});

	provide('computer_hardware', props.computer_info.hardwares);
</script>
